/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_SplitInputs */

const cs_ebr_diff_split = /** @type {(inputs: Ebr_Diff_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedle sebe`)
};

const en_ebr_diff_split = /** @type {(inputs: Ebr_Diff_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side by side`)
};

/**
* | output |
* | --- |
* | "Side by side" |
*
* @param {Ebr_Diff_SplitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_split = /** @type {((inputs?: Ebr_Diff_SplitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_SplitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_split(inputs)
	return cs_ebr_diff_split(inputs)
});